import styled from "styled-components";

export const Container = styled.div`
  & > div {
    margin-bottom: 3.6rem;
  }
`;

export const NotificationSideDiv = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
      
  `}
  align-items: center;
  display: flex;
  margin-bottom: 0.8rem;
  img {
    height: 3rem;
    width: 3rem;
  }
`;

interface INotificationDiv {
  fontSize?: string;
  fontWeight?: string | number;
  marginLeft?: string;
  marginTop?: string;
}
export const NotificationDiv = styled.div<INotificationDiv>`
  ${(props) => `
      color: ${props.color ? props.color : "#2E353D"};
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size:${props.fontSize ? props.fontSize : "1.3rem"};
      font-weight:${props.fontWeight ? props.fontWeight : 500};
      margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
      margin-top:${props.marginTop ? props.marginTop : "0rem"};
 `}
  font-style: normal;
  .img-notification {
    height: 2.4rem;
    width: 2rem;
  }
`;

interface IIconNotificationDiv {
  marginRight?: string;
  marginTop?: string;
}
export const IconNotificationDiv = styled.div<IIconNotificationDiv>`
  ${(props) => `
      margin-right: ${props.marginRight ? props.marginRight : "0rem"};
      margin-top:${props.marginTop ? props.marginTop : "0rem"};
 `}
  .icon-size {
    width: 4rem;
    height: 4rem;
    cursor: not-allowed;
  }
`;

interface INotificationCount {
  fontSize?: string;
  fontWeight?: string | number;
  marginLeft?: string;
  marginTop?: string;
  padding?: string;
}
export const NotificationCount = styled.div<INotificationCount>`
  ${(props) => `
      color: ${props.color ? props.color : "#FFFFFF"};
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size:${props.fontSize ? props.fontSize : "1.15rem"};
      font-weight:${props.fontWeight ? props.fontWeight : 500};
      margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
      margin-top:${props.marginTop ? props.marginTop : "0rem"};
      padding:${props.padding ? props.padding : "0.4rem"};
 `}
  font-style: normal;
  background: #ff6f61;
  border-radius: 10px;
`;

interface INotificationPositionAbs {
  width?: string;
}
export const NotificationPositionAbs = styled.div<INotificationPositionAbs>`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
      width:${props.width ? props.width : "21rem"};
 `}
  display: flex;
  justify-content: flex-end;
  position: absolute;
`;

export const NotificationjustifyDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  .width-height {
    height: 5rem;
    width: 20rem;
  }
`;

export const HeaderDocumentDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

export const HeaderTitleDocumentDiv = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
 `}
  align-items: center;
  color: rgba(16, 15, 87, 0.49);
  display: flex;
  font-size: 1.2rem;
  font-weight: 700;
`;

interface IDivGenericThird {
  fontSize?: string;
  fontWeight?: string | number;
  marginTop?: string;
}

export const DivGenericThird = styled.div<IDivGenericThird>`
  ${(props) => `
      color: ${props.color ? props.color : "#2E353D"}; 
      font-family: ${props.theme.fontFamilies.primaryFont};
      font-size: ${props.fontSize ? props.fontSize : "0rem"}; 
      font-weight: ${props.fontWeight ? props.fontWeight : "500"}; 
      margin-top: ${props.marginTop ? props.marginTop : "0rem"};
      overflow-wrap: break-word;
 `}
`;
